import DashboardLayout from "./DashboardLayout";
import EnterpriseSidebar from "../navigation/EnterpriseSidebar";
import EnterpriseTopBar from "../navigation/EnterpriseTopBar";

export default function EnterpriseShell({
  title = "ShiftBridge Enterprise",
  subtitle = "",
  activeKey,
  navigationItems = [],
  onNavigate,
  topRight,
  children,
}) {
  return (
    <DashboardLayout
      sidebar={
        <EnterpriseSidebar
          activeKey={activeKey}
          items={navigationItems}
          onNavigate={onNavigate}
        />
      }
      topbar={
        <EnterpriseTopBar
          title={title}
          subtitle={subtitle}
          right={topRight}
        />
      }
    >
      {children}
    </DashboardLayout>
  );
}